export default {
    computed: {
        productItems() {
            return this.stock ? this.stock.items.filter(item => item.product) : []
        },
        getProductsByCategory() {
            return category => {
                if (this.filters.name) {
                    return this.productItems.filter(item => item.product.active && item.product.categories.some(c => c.id === category.id)).filter(item => item.product.name.toLowerCase().includes(this.filters.name.toLowerCase()))
                }
                return this.productItems.filter(item => item.product.active && item.product.categories.some(c => c.id === category.id))
            }
        },
        hasCategoryProducts() {
            return category => {
                return this.getProductsByCategory(category).length > 0
            }
        },
        getStockProductQuantity() {
            return productId => {
                let product = this.productItems.find(item => item.product && item.product.id === productId)
                return product ? product.quantity : 0
            }

        }
    }

}
